import * as eventsModule from 'events';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './Store/store';

const resolveEventEmitter = () => {
  if (typeof eventsModule === 'function') return eventsModule;
  if (eventsModule && typeof eventsModule.EventEmitter === 'function') return eventsModule.EventEmitter;
  if (eventsModule && typeof eventsModule.default === 'function') return eventsModule.default;
  if (eventsModule && eventsModule.default && typeof eventsModule.default.EventEmitter === 'function') return eventsModule.default.EventEmitter;
  
  class FallbackEventEmitter {
    constructor() { this._events = {}; }
    on(event, listener) {
      (this._events[event] = this._events[event] || []).push(listener);
      return this;
    }
    off(event, listener) {
      if (!this._events[event]) return this;
      this._events[event] = this._events[event].filter(l => l !== listener);
      return this;
    }
    removeListener(event, listener) { return this.off(event, listener); }
    emit(event, ...args) {
      if (!this._events[event]) return false;
      this._events[event].forEach(l => { try { l(...args); } catch(e){} });
      return true;
    }
    removeAllListeners(event) {
      if (event) delete this._events[event];
      else this._events = {};
      return this;
    }
  }
  return FallbackEventEmitter;
};

const EventEmitter = resolveEventEmitter();

if (typeof window !== 'undefined') {
  window.EventEmitter = EventEmitter;
}
if (typeof global !== 'undefined') {
  global.EventEmitter = EventEmitter;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
